export interface ITradingParameters {
  asset: string;
  max_position_quote_asset: string;
  max_increase_position_offset_bps: string;
  max_decrease_position_offset_bps: string;
  amount_multiplier: string;
  offset_multiplier: string;
  updated_at?: string;
}

export const TRADING_PARAMS_TITLES: Record<keyof Omit<ITradingParameters, "asset" | "updated_at">, string> = {
  max_position_quote_asset: "Max Position Quote Asset",
  max_increase_position_offset_bps: "Max Increase Position Offset (bps)",
  max_decrease_position_offset_bps: "Max Decrease Position Offset (bps)",
  amount_multiplier: "Amount Multiplier",
  offset_multiplier: "Offset Multiplier",
};
